import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from '../app/login/login.component'
import {MenuComponent} from '../app/menu/menu.component'
import {DataComponent} from '../app/data/data.component'
import { GuardServiceGuard } from './guard-service.guard';



const routes: Routes = [
  { path: 'login-component', component: LoginComponent },
  { path: 'menu-component', component: MenuComponent,canActivate: [GuardServiceGuard] },
  { path: 'data-component', component: DataComponent,canActivate: [GuardServiceGuard] },
  { path: '**'  , component:LoginComponent  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
